import * as React from "react";
import { useSelector } from "react-redux";
import axios from 'axios';
import { Modal, Button } from 'react-bootstrap';

import closeIcon from '../assets/images/cross-close.svg';
const { useState, useEffect } = React;

export const WaitingListEnabledWindow = ({ showConfirmWindow, handleConfirmWindowClose, waitingAlertMessage, isWaitingListEnabled, setIsWaitingListEnabled }) => {
    const reduxLanguageTranslations = useSelector(state => state.selectedLanguageTranslations.selectedLanguageTranslations);

    const changeWaitingListStatus = (value) => {
        if (value == true) {
            setIsWaitingListEnabled(!isWaitingListEnabled);
        } else {
            setIsWaitingListEnabled(isWaitingListEnabled);
        }
        handleConfirmWindowClose();
    }

    return (
        <>
            <Modal show={showConfirmWindow} onHide={handleConfirmWindowClose} className="modalStyle p-0">
                <Modal.Body className="p-0">
                    <div className="modal-container">
                        <div className="d-flex justify-content-between mb-4">
                            <p className="form-title">
                                {reduxLanguageTranslations ? reduxLanguageTranslations["waitingListEnabledSubHeading"] : "Waiting list Enabled"}
                            </p>
                            <img src={closeIcon} onClick={handleConfirmWindowClose} className="cursor-pointer" />
                        </div>
                        <div className="d-flex justify-content-between mb-4">
                            {isWaitingListEnabled ?
                                reduxLanguageTranslations ? reduxLanguageTranslations["allContactsNoEmail"] : "All contacts in the existing waiting list will not receive any emails."
                                :
                                reduxLanguageTranslations ? reduxLanguageTranslations["waitingListEnabledInfo"] : "You are waiting list functionality enabled."
                            }
                        </div>
                        <div className="d-flex">
                            <button className="filter-btn site-btn-padd border-dark color-dark w-100 me-3" id="cancel" onClick={() => changeWaitingListStatus(false)}>{reduxLanguageTranslations ? reduxLanguageTranslations["eventDeleteWindowModalCancelBtn"] : "Cancel"}</button>
                            <button className="site-btn site-btn-padd w-100" id="confirm" onClick={() => changeWaitingListStatus(true)}>{reduxLanguageTranslations ? reduxLanguageTranslations["eventDeleteWindowModalConfirmBtn"] : "Confirm"}</button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}